var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.styles)?_c('style',{tag:"component"},[_vm._v("\n    "+_vm._s(_vm.styles)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{ref:"el",staticClass:"cms-block",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }